import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Location } from '@angular/common';
import { filter, takeUntil } from 'rxjs/operators';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { GoogleAnalyticsService } from 'src/app/core/services/google-tag-manager.service';
import { combineLatest, Observable, Subject } from 'rxjs';
import { ISelectedContract, LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { ActivatedRoute, Router } from '@angular/router';
import { GSSPAuthenticationService } from 'src/app/core/services/gssp-authentication.service';
import { ADPResourceService } from 'digital-core';
import { StorageService } from 'src/app/core/services/storage.service';
import { UtilityService } from 'src/app/core/services/utility.service';
import { AccountService } from 'src/app/core/services/account.service';
import { UUID } from 'angular2-uuid';
import { IPromoSlot } from 'src/app/model/promos/IPromoSlot';
import { GlobalModalWindowService } from 'src/app/core/services/global-modal-window.service';
import { ContractDetailsPDFService } from 'src/app/core/services/contract-details-pdf.service';
import { PreInitSettingsService } from 'src/app/core/services/settings/pre-init-setting.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CryptoService } from 'src/app/core/services/cypto/crypto.service';
import { DecryptedDocsData, MWCDocumentsData } from 'src/app/core/services/cypto/crypto-docs-response.dto';
import { OktaUserProfile } from 'src/app/model/okta/userClaims';
import { GlobalModalWindowComponent } from 'src/app/shared/components/global-modal-window/global-modal-window.component';
import { CoverageDocsModalComponent } from './coverage-docs-modal/coverage-docs-modal-component/coverage-docs-modal-component.component';

@Component({
  selector: 'pgh-coverage',
  templateUrl: './coverage.component.html',
  styleUrls: ['./coverage.component.scss'],
})
export class CoverageComponent implements OnInit, OnDestroy {

  @Input() isMobileProductTemplate: boolean = false;
  @Input() isHomeTechProductTemplate: boolean = false;

  private onDestroy$ = new Subject<void>();
  public promoSlot: IPromoSlot;

  ePolicyIdentifier: string = '';
  isExpired: boolean = false;
  isContractMissing: boolean = false;
  fileURL: string;
  selectedContract: ISelectedContract;
  isViewContractFromSitefinity = false;
  contractNumber: string;
  isClientSoldType = false;
  clientId: string = '';
  associateNumber: string = '';
  trackingId = UUID.UUID();
  fileContent: any;
  fileName: any;
  IsPdfView: boolean = false;
  base64: any = '';
  isNative: boolean = false;
  testEprimContractId: string = '';
  ePrismDdocsArr : MWCDocumentsData[] = [];

  public isMobileSize: boolean = false;
  private destroy$ = new Subject<boolean>();

  public productTitleKey: string = '';
  public productDescriptionKey: string = '';
  public coverageOneTitleKey: string = ''
  public coverageOneDescriptionKey: string = '';
  public coverageTwoTitleKey: string = '';
  public coverageTwoDescriptionKey: string = '';
  public coverageThreeTitleKey: string = '';
  public coverageThreeDescriptionKey: string = '';
  public coverageFourTitleKey: string = '';
  public coverageFourDescriptionKey: string = '';
  public allFAQsRoute: string = '';

  constructor(
    public route: ActivatedRoute,
    private router: Router,
    private utilityService: UtilityService,
    private loggedInUserSettings: LoggedInUserSettings,
    private storageService: StorageService,
    public httpClient: HttpClient,
    private resourceService: ADPResourceService,
    private errorDialogService: GlobalModalWindowService,
    private contractDetailsPDFService: ContractDetailsPDFService,
    private preInitSettingsService: PreInitSettingsService,
    private breakpointObserver: BreakpointObserver,
    private cryptoService: CryptoService,
    private globalModalWindowService: GlobalModalWindowService,
    private matDialog: MatDialog,
  ) {
    this.breakpointObserver.observe([Breakpoints.XSmall]).subscribe((result) => {
          this.isMobileSize = result.matches;
        });
    this.route.queryParams.subscribe((params) => {
      this.isNative = (params.isNative && params.isNative.toLowerCase().trim() === 'true') || this.utilityService.isNativeApp;
      this.testEprimContractId = params['testEprimContractId'];
    });
    this.clientId = this.preInitSettingsService.getSettings().middleWare.clientId;
    this.associateNumber = this.preInitSettingsService.getSettings().middleWare.associateNumber;
  }

  @HostListener('window:resize', ['$event'])
    onResize(event) {
      this.isMobileSize = window.innerWidth < 992;
  }

  ngOnInit() {

    this.promoSlot = {
      heading: 'Coverage_Promo_Heading',
      promoText: 'Coverage_Promo_Text',
      imageKey: 'Global_TechServices_Promo_TechSupport_ImageKey',
      callToActionLabel: this.isMobileProductTemplate ? 'Coverage_Promo_CallToAction_Button_Label' : 'Coverage_Promo_CallToAction_Support_Button_Label',
      isPromoAppType: false,
    };
    const joined$ = combineLatest(
      [
        this.loggedInUserSettings.$selectedContract,
        this.loggedInUserSettings.$eprismContracts,
      ]
    ).pipe(
      filter(([a]) => a !== null),
      takeUntil(this.destroy$)
    );

    joined$.subscribe(([selectedContract, eprismContracts]: [ISelectedContract, any[]]) => {
      if (selectedContract && !this.selectedContract) {
        this.isClientSoldType = this.resourceService.isPortalSettingTrue('Global_Client_IsClientSoldType');
        this.isViewContractFromSitefinity = this.resourceService.isPortalSettingTrue('Global_ViewContract_From_Sitefinity');
        this.selectedContract = selectedContract;
        this.contractNumber = selectedContract.id;
      }
      if (eprismContracts && eprismContracts.length > 0) {

        let oktaUserProfile = this.storageService.getLocal<OktaUserProfile>('okta-user-profile');
        const eContract = eprismContracts.find(x => x.policyIdentifier.mobileNumber == oktaUserProfile.primaryPhone);
        this.ePolicyIdentifier = this.testEprimContractId != undefined ? this.testEprimContractId : eContract.policyIdentifier.mobileNumber;
      }
    }
    );
    this.loadTemplateContent();
  }

  ngOnDestroy() {
    document.documentElement.className = '';
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  loadTemplateContent(){

    if(this.isMobileProductTemplate){
      this.productTitleKey = this.resourceService.getPortalLabel("Coverage_Details_ProductTitle_Eprism_Mobile").ResourceKey;
      this.productDescriptionKey = this.resourceService.getPortalLabel("Coverage_Details_ProductDescription_Eprism_Mobile").ResourceKey;
      this.coverageOneTitleKey = this.resourceService.getPortalLabel("Coverage_Details_Title_AccDamage_Eprism_Mobile").ResourceKey;
      this.coverageOneDescriptionKey = this.resourceService.getPortalLabel("Coverage_Details_Description_AccDamage_Eprism_Mobile").ResourceKey;
      this.coverageTwoTitleKey = this.resourceService.getPortalLabel("Coverage_Details_Title_LossTheft_Eprism_Mobile").ResourceKey;
      this.coverageTwoDescriptionKey = this.resourceService.getPortalLabel("Coverage_Details_Description_LossTheft_Eprism_Mobile").ResourceKey;
      this.coverageThreeTitleKey = this.resourceService.getPortalLabel("Coverage_Details_Title_ScreenDamage_Eprism_Mobile").ResourceKey;
      this.coverageThreeDescriptionKey = this.resourceService.getPortalLabel("Coverage_Details_Description_ScreenDamage_Eprism_Mobile").ResourceKey;
      this.coverageFourTitleKey = this.resourceService.getPortalLabel("Coverage_Details_Title_MechanicalFailure_Eprism_Mobile").ResourceKey;
      this.coverageFourDescriptionKey = this.resourceService.getPortalLabel("Coverage_Details_Description_MechanicalFailure_Eprism_Mobile").ResourceKey;
      this.allFAQsRoute = '/p360-faq';
    }
    else if(this.isHomeTechProductTemplate){
      this.productTitleKey = this.resourceService.getPortalLabel("Coverage_Details_ProductTitle_HomeTech").ResourceKey;
      this.productDescriptionKey = this.resourceService.getPortalLabel("Coverage_Details_ProductDescription_HomeTech").ResourceKey;


      this.coverageOneTitleKey = this.resourceService.getPortalLabel("Coverage_Details_Title_UnlimitedDevices_HomeTech").ResourceKey;
      this.coverageOneDescriptionKey = this.resourceService.getPortalLabel("Coverage_Details_Description_UnlimitedDevices_HomeTech").ResourceKey;

      this.coverageTwoTitleKey = this.resourceService.getPortalLabel("Coverage_Details_Title_AccDamage_HomeTech").ResourceKey;
      this.coverageTwoDescriptionKey = this.resourceService.getPortalLabel("Coverage_Details_Description_AccDamage_HomeTech").ResourceKey;

      this.coverageThreeTitleKey = this.resourceService.getPortalLabel("Coverage_Details_Title_MechanicalBreakdown_HomeTech").ResourceKey;
      this.coverageThreeDescriptionKey = this.resourceService.getPortalLabel("Coverage_Details_Description_MechanicalBreakdown_HomeTech").ResourceKey;

      this.coverageFourTitleKey = this.resourceService.getPortalLabel("Coverage_Details_Title_LiveTechSupport_HomeTech").ResourceKey;
      this.coverageFourDescriptionKey = this.resourceService.getPortalLabel("Coverage_Details_Description_LiveTechSupport_HomeTech").ResourceKey;
      this.allFAQsRoute = '/faq';
    }
  }

  loadPdf() {
    const hasMultipleClient = this.resourceService.isPortalSettingTrue('Global_HasMultipleClient');
    if (this.fileURL) {
      window.open(this.fileURL);
    } else if (this.isViewContractFromSitefinity) {
      if (hasMultipleClient) {
        this.fileURL = this.resourceService.getPortalSetting('URL_Doc_' + this.selectedContract.masterPlanCode)?.Value;
        if (!this.fileURL) {
          this.errorDialogService.displaySimpleErrorModal('Global_Error_PlanCode_Doc_NotFound');
          return;
        }
        window.open(this.fileURL);
      } else if (this.isClientSoldType) {
        this.fileURL = this.resourceService.getPortalSetting('URL_Terms_And_Conditions').Value;
        window.open(this.fileURL);
      }
    } else {
      if (this.isMobileProductTemplate) {
        if (this.ePrismDdocsArr && this.ePrismDdocsArr.length > 0) {
          this.handleOpenMWCDocs();
        } else {
          let stringToEncrypt: string = "";

          const currentDate = new Date();
          let utcIsoString = currentDate.toISOString();

          stringToEncrypt += "Timestamp=" + utcIsoString + "|";
          stringToEncrypt += "Lookup_Number=" + this.ePolicyIdentifier + "|";
          stringToEncrypt += "EF_Code=" + this.resourceService.getPortalSetting('Coverage_MWC_Docs_EF_Code').Value + "|";
          stringToEncrypt += "Version=2";

          this.cryptoService.mwcEncryptData(stringToEncrypt, 'Secure_MWC_Docs').subscribe(
            res => {
              let encodedToken = encodeURIComponent(res.encryptedData)
              let url = this.resourceService.getPortalSetting('URL_External_MWC_Docs').Value + encodedToken;
              this.httpClient.get(url,{ responseType: 'text'}).subscribe(
                (purlEncrypted) => {
                  this.cryptoService.mwcDecryptData(decodeURIComponent(purlEncrypted), 'Secure_MWC_Docs').subscribe(
                    purlDecrypted => {
                      let decrypted: DecryptedDocsData = null;
                      try {
                        decrypted = JSON.parse(purlDecrypted.decryptedData);
                      }
                      catch (e) {
                        console.log(e);
                        this.globalModalWindowService.displaySimpleErrorModal('Global_Error_MWC_Coverage_No_Docs','Global_Error_MWC_Coverage_No_Docs_Header');
                      }
                      if (decrypted && decrypted.success) {
                        if (decrypted.documents && decrypted.documents.length > 0) {
                          this.ePrismDdocsArr = decrypted.documents;
                          this.handleOpenMWCDocs();
                        }
                      }
                    });
                },
                (error) => {
                  console.log(error);
                  this.globalModalWindowService.displaySimpleErrorModal('Global_Error_MWC_Coverage_No_Docs','Global_Error_MWC_Coverage_No_Docs_Header');
                }
              );
            }
          ),
            (error) => {
              console.log(error);
              this.globalModalWindowService.displaySimpleErrorModal('Global_Error_MWC_Coverage_No_Docs');
            };
        }
      } else {
        this.isContractMissing = true;
        this.contractDetailsPDFService
          .getCoverageDocument(this.contractNumber, this.clientId, this.trackingId, this.associateNumber)
          .subscribe(
            (res) => {
              if (res.FileContent) {
                this.fileContent = res.FileContent;
                this.fileName = res.FileName;
              }
              this.preparePdf();
              this.isContractMissing = false;
            },
            (error) => {
              this.isContractMissing = false;
              throw error;
            }
          );
      }
    }
  }

  preparePdf() {
    if (this.IsPdfView) {
      this.base64 = this.fileContent;
    }
    if (this.isNative) {
      const rnWindow = window as any;
      if (rnWindow.ReactNativeWebView) {
        const message = JSON.stringify({ action: 'openContract', args: {} });
        rnWindow.ReactNativeWebView.postMessage(message);
      }
    } else {
      const byteCharacters = atob(this.fileContent);
      const byteNumbers = new Array(byteCharacters.length);

      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      const file = new Blob([byteArray], { type: 'application/pdf' });
      const URL = window.URL || window.webkitURL;
      this.fileURL = URL.createObjectURL(file);
      window.open(this.fileURL);
    }
  }

  getViewLabel(item: string) {
    const label = this.resourceService.getViewLabel(item) ?? '';
    return this.resourceService.transformContentData(label);
  }

  handleViewCoverageDocuments(event: any){
    this.loadPdf();
  }

  handleOpenMWCDocs() {
    if (this.ePrismDdocsArr && this.ePrismDdocsArr.length > 0) {
      if (this.ePrismDdocsArr.length == 1)
        window.open(this.ePrismDdocsArr[0].docID, '_blank', 'noopener,noreferrer');
      else {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.disableClose = true;
        dialogConfig.id = 'list-coverage-docs-dialog';
        dialogConfig.height = 'auto';
        dialogConfig.ariaLabel = this.resourceService.getLabel('Global_Modal_Coverage_Docs_Title');
        dialogConfig.data = {
          "docsArr": this.ePrismDdocsArr
        };

        this.matDialog.open(CoverageDocsModalComponent, dialogConfig);
      }
    }
  }


  handleViewFAQs(event: any) {
    if (this.isMobileProductTemplate) {
      this.router.navigate(['/p360-faq']) ;
    } else {
      this.router.navigate(['/faq']);
    }
  }

}
